import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import translation files
import enTranslations from './locales/en.json';
import viTranslations from './locales/vi.json';

const resources = {
  en: {
    translation: enTranslations
  },
  vi: {
    translation: viTranslations
  }
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: localStorage.getItem('language') || 'en', // language to use, more information here: https://www.i18next.com/overview/configuration-options#languages-namespaces-resources
    fallbackLng: 'en', // use en if detected lng is not available

    keySeparator: '.', // we use content as keys

    interpolation: {
      escapeValue: false, // react already does escaping
      format: function(value, format, lng) {
        // Custom formatting for numbers and dates
        if (format === 'number') {
          return new Intl.NumberFormat(lng === 'vi' ? 'vi-VN' : 'en-US').format(value);
        }
        if (format === 'currency') {
          return new Intl.NumberFormat(lng === 'vi' ? 'vi-VN' : 'en-US', {
            style: 'currency',
            currency: lng === 'vi' ? 'VND' : 'USD'
          }).format(value);
        }
        return value;
      }
    },

    // Save language preference to localStorage
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage']
    }
  });

export default i18n;
